import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faTiktok, faAndroid, faApple } from "@fortawesome/free-brands-svg-icons";
import { faAngleRight, faAngleLeft, faDownload } from "@fortawesome/free-solid-svg-icons";
import playstoreBadge from './badge/google-play-badge.png'
import Slider from 'react-slick';
import { Asset } from 'expo-asset';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.css'; // ボタンのスタイルを定義したCSSファイルをインポート


import tonarerIcon from './assets/icons/tonarerIcon.png'
import taptapIcon from './assets/icons/taptapIcon.png'
import realSpeakIcon from './assets/icons/realSpeakIcon.png'
import ijinworldIcon from './assets/icons/ijinworldIcon.png'
import ijinIcon from './assets/icons/ijinIcon.png'
import oyasumiIcon from './assets/icons/oyasumiIcon.png'
import linesPlayerIcon from './assets/icons/linesPlayerIcon.png'
import firesignIcon from './assets/icons/firesignIcon.png'
import mimawariIcon from './assets/icons/mimawariIcon.png'
import geostockIcon from './assets/icons/geostockIcon.png'
import musictimerIcon from './assets/icons/musictimerIcon.png'
import shiraseIcon from './assets/icons/shiraseIcon.png'
import dotIcon from './assets/icons/dotitemIcon.png'


import tonarerSS1 from './assets/screenshots/tonarer1.png'
import tonarerSS2 from './assets/screenshots/tonarer2.png'
import taptapSS1 from './assets/screenshots/taptap1.png'
import taptapSS2 from './assets/screenshots/taptap2.png'
import realSpeakSS1 from './assets/screenshots/realSpeak1.png'
import realSpeakSS2 from './assets/screenshots/realSpeak2.png'
import ijinworldSS1 from './assets/screenshots/ijinworld1.png'
import ijinworldSS2 from './assets/screenshots/ijinworld2.png'
import ijinSS1 from './assets/screenshots/ijin1.png'
import ijinSS2 from './assets/screenshots/ijin2.png'
import oyasiumiSS1 from './assets/screenshots/oyasumi1.png'
import oyasiumiSS2 from './assets/screenshots/oyasumi2.png'
import linesPlayerSS2 from './assets/screenshots/linesPlayer2.png'
import linesPlayerSS1 from './assets/screenshots/linesPlayer1.png'
import firesignSS2 from './assets/screenshots/firesign2.png'
import firesignSS1 from './assets/screenshots/firesign1.png'
import mimawariSS2 from './assets/screenshots/mimawari2.png'
import mimawariSS1 from './assets/screenshots/mimawari1.png'
import geostockSS1 from './assets/screenshots/geostock1.png'
import geostockSS2 from './assets/screenshots/geostock2.png'
import musictimerSS1 from './assets/screenshots/musictimer1.png'
import musictimerSS2 from './assets/screenshots/musictimer2.png'
import shiraseSS1 from './assets/screenshots/shirase1.png'
import shiraseSS2 from './assets/screenshots/shirase2.png'
import dotitemSS1 from './assets/screenshots/dotitem1.png'
import dotitemSS2 from './assets/screenshots/dotitem2.png'

const apps = [
  {
    name: 'Mr.Tonarer',
    icon: tonarerIcon,
    description: "男子トイレの暗黙のルール！\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/jp/app/id6742400813",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa.gentlestand",
    ss1: tonarerSS1,
    ss2: tonarerSS2,
  },
  {
    name: 'Top of Tap',
    icon: taptapIcon,
    description: "全世界のユーザーと反射神経を競うシンプルなゲームアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/jp/app/%E3%82%B7%E3%83%B3%E3%83%97%E3%83%AB%E3%82%B2%E3%83%BC%E3%83%A0%E3%81%A7%E5%8F%8D%E5%B0%84%E7%A5%9E%E7%B5%8C%E3%83%86%E3%82%B9%E3%83%88-top-of-tap/id6740491510",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa.TapTap",
    ss1: taptapSS1,
    ss2: taptapSS2,
  },
  {
    name: '台本英会話',
    icon: realSpeakIcon,
    description: "ひとりごとや友達との会話を英語の台本にしてくれる英会話アプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/jp/app/%E5%8F%B0%E6%9C%AC%E8%8B%B1%E4%BC%9A%E8%A9%B1-%E3%83%BC%E3%81%B2%E3%81%A8%E3%82%8A%E3%81%94%E3%81%A8%E3%82%84%E5%8F%8B%E9%81%94%E3%81%A8%E3%81%AE%E4%BC%9A%E8%A9%B1%E3%81%A7%E8%8B%B1%E4%BC%9A%E8%A9%B1-%E3%83%BC/id6738711605",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa.RealiSpeak",
    ss1: realSpeakSS1,
    ss2: realSpeakSS2,
  },
  {
    name: '語り部チャット世界史',
    icon: ijinworldIcon,
    description: "世界史の偉人たちと友達感覚でチャットするAIアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/jp/app/%E8%AA%9E%E3%82%8A%E9%83%A8%E3%83%81%E3%83%A3%E3%83%83%E3%83%88%E4%B8%96%E7%95%8C%E5%8F%B2-%E3%83%BC%E4%B8%96%E7%95%8C%E3%81%AE%E5%81%89%E4%BA%BA%E3%81%9F%E3%81%A1%E3%81%A8ai%E3%83%81%E3%83%A3%E3%83%83%E3%83%88/id6608975313",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa1225.ijinchatworld",
    ss1: ijinworldSS1,
    ss2: ijinworldSS2,
  },
  {
    name: '語り部チャット',
    icon: ijinIcon,
    description: "偉人たちと友達感覚でチャットするAIアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/jp/app/%E8%AA%9E%E3%82%8A%E9%83%A8%E3%83%81%E3%83%A3%E3%83%83%E3%83%88-%E3%83%BC%E5%81%89%E4%BA%BA%E3%81%9F%E3%81%A1%E3%81%A8%E3%83%81%E3%83%A3%E3%83%83%E3%83%88%E3%82%92%E6%A5%BD%E3%81%97%E3%82%80ai%E3%82%A2%E3%83%97%E3%83%AA/id6523432812",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa1225.ijinchat",
    ss1: ijinSS1,
    ss2: ijinSS2,
  },
  {
    name: 'おやすみアナウンス',
    icon: oyasumiIcon,
    description: "就寝時間にスマホから「蛍の光」が流れるアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/jp/app/%E3%81%8A%E3%82%84%E3%81%99%E3%81%BF%E3%82%A2%E3%83%8A%E3%82%A6%E3%83%B3%E3%82%B9-%E8%9B%8D%E3%81%AE%E5%85%89%E3%81%A7%E3%82%B9%E3%83%9E%E3%83%9B%E4%BE%9D%E5%AD%98%E5%AF%BE%E7%AD%96-%E5%AF%9D%E4%B8%8D%E8%B6%B3%E6%94%B9%E5%96%84/id6479048824",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa1225.firefly&pli=1",
    ss1: oyasiumiSS1,
    ss2: oyasiumiSS2,
  },
  {
    name: 'セリフで日常BGM',
    icon: linesPlayerIcon,
    description: "自分のセリフでBGMが流れるアプリ\n(iOSのみ)",
    iosUrl: "https://apps.apple.com/jp/app/%E3%82%BB%E3%83%AA%E3%83%95%E3%81%A7%E6%97%A5%E5%B8%B8bgm/id6480062741",
    androidUrl: "https://apps.apple.com/jp/app/%E3%82%BB%E3%83%AA%E3%83%95%E3%81%A7%E6%97%A5%E5%B8%B8bgm/id6480062741",
    ss1: linesPlayerSS1,
    ss2: linesPlayerSS2,
  },
  {
    name: 'Fire Sign',
    icon: firesignIcon,
    description: "1人で頑張る人たちを結ぶ集中アプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/us/app/fire-sign-1人で頑張る人たちのための集中アプリ/id6476833148",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa1225.firesign",
    ss1: firesignSS1,
    ss2: firesignSS2,
  },
  {
    name: 'おやすみ通知',
    icon: mimawariIcon,
    description: "就寝時間を先生が知らせてくれるアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/us/app/おやすみ通知-就寝時間を通知でお知らせ/id6474501976",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa1225.mimawari_sleep",
    ss1: mimawariSS1,
    ss2: mimawariSS2,
  },
  {
    name: 'Geo Stock',
    icon: geostockIcon,
    description: "移動中気になった場所を即記録するアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/ja/app/geo-stock/id6453600415",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa1225.geoStock",
    ss1: geostockSS1,
    ss2: geostockSS2,
  },
  {
    name: '動画&音楽でタイマー',
    icon: musictimerIcon,
    description: "YouTube動画や音楽をタイマー代わりに使うアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/ja/app/audio-duration-player/id6444570417",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa1225.newMusicTimer0421",
    ss1: musictimerSS2,
    ss2: musictimerSS1,
  },
  {
    name: 'shirase',
    icon: shiraseIcon,
    description: "さりげなく友達を誘えるSNSアプリ\n(iOS/Android)",
    iosUrl: "https://apps.apple.com/ja/app/shirase-ーさりげなく友達を誘えるアプリー/id1594209501",
    androidUrl: "https://play.google.com/store/apps/details?id=com.sawa.shirase",
    ss1: shiraseSS1,
    ss2: shiraseSS2
  },
  {
    name: 'ドット持ち物',
    icon: dotIcon,
    description: "アイテム画面風持ち物リストアプリ\n(iOSのみ)",
    iosUrl: "https://apps.apple.com/ja/app/ドット持ち物/id1584988591",
    androidUrl: "https://apps.apple.com/ja/app/ドット持ち物/id1584988591",
    ss1: dotitemSS1,
    ss2: dotitemSS2
  },
];

function ScreenShots({ appIndex }) {
  return (
    <div className="SScontainer">
      <div className="screenshot1">
        <img
          src={apps[appIndex].ss1}
          style={{
            borderRadius: 10,
            width: 250,
            maxHeight: 525,
            objectFit: 'cover',
            objectPosition: 'top',
            opacity: 0.8,
          }}
        />
      </div>
      <div className="screenshot2">
        <img
          src={apps[appIndex].ss2}
          style={{
            borderRadius: 10,
            width: 250,
            maxHeight: 525,
            objectFit: 'cover',
            objectPosition: 'top',
            opacity: 0.8,
          }}
        />
      </div>
    </div>
  )
}

function Title() {
  return (
    <div className="hero-section">
      <h1 className="title">さわーん's App</h1>
      <p className="subtitle">
        思いつきでアプリを作っています。
      </p>
      <SocialButtons />
    </div>
  );
}

function SocialButtons() {
  return (
    <div className="social-buttons">
      <a href="https://twitter.com/sdddd_hkr" target="_blank" rel="noopener noreferrer" className="social-link">
        <FontAwesomeIcon icon={faTwitter} />
        <span>Twitter</span>
      </a>
      <a href="https://www.tiktok.com/@lines.bgm" target="_blank" rel="noopener noreferrer" className="social-link">
        <FontAwesomeIcon icon={faTiktok} />
        <span>TikTok</span>
      </a>
    </div>
  );
}

function AppIcon({ appIndex, setAppIndex }) {
  const sliderRef = useRef(null);

  const settings = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  useEffect(() => {
    sliderRef.current.slickGoTo(appIndex);
  }, [appIndex]);

  const openAppUrl = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // Android device
    if (/android/i.test(userAgent)) {
      window.open(apps[appIndex].androidUrl, '_blank');
    }
    // iOS device
    else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open(apps[appIndex].iosUrl, '_blank');
    }
    // Other device...
    else {
      window.open(apps[appIndex].androidUrl, '_blank');
    }
  }

  return (
    <div className="app-showcase">
      <button className="nav-button prev" onClick={() => {
        setAppIndex((appIndex + apps.length - 1) % apps.length);
      }}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </button>

      <div className="app-content">
        <div className="app-icon" onClick={openAppUrl}>
          <Slider ref={sliderRef} {...settings}>
            {apps.map((app, index) => (
              <img
                key={index}
                src={app.icon}
                alt={`${app.name} icon`}
              />
            ))}
          </Slider>
        </div>

        <div className="app-info">
          <h2 className="app-name">{apps[appIndex].name}</h2>
          <p className="app-description">{apps[appIndex].description}</p>

          <div className="app-links">
            {apps[appIndex].iosUrl && (
              <a href={apps[appIndex].iosUrl} target="_blank" rel="noopener noreferrer" className="store-link">
                <FontAwesomeIcon icon={faApple} />
                <span>App Store</span>
              </a>
            )}
            {apps[appIndex].androidUrl && apps[appIndex].androidUrl !== apps[appIndex].iosUrl && (
              <a href={apps[appIndex].androidUrl} target="_blank" rel="noopener noreferrer" className="store-link">
                <FontAwesomeIcon icon={faAndroid} />
                <span>Play Store</span>
              </a>
            )}
          </div>
        </div>
      </div>

      <button className="nav-button next" onClick={() => {
        setAppIndex((appIndex + 1) % apps.length);
      }}>
        <FontAwesomeIcon icon={faAngleRight} />
      </button>
    </div>
  );
}

function AppName({ appIndex }) {
  return (
    <div>
      <h1 className="appName">{apps[appIndex].name}</h1>
    </div>
  );
}

function AppDescription({ appIndex }) {
  return (
    <div>
      <h1 className="appDescription">{apps[appIndex].description}</h1>
    </div>
  );
}

function AppList({ appIndex, setAppIndex }) {
  return (
    <div className="app-list">
      {apps.map((app, index) => (
        <img
          key={index}
          src={app.icon}
          alt={`${app.name} icon`}
          className="app-list-item"
          onClick={() => setAppIndex(index)}
          style={{
            border: appIndex === index ? '2px solid hsla(0,0%,100%,0.3)' : '',
            width: appIndex === index ? '35px' : '30px',
            height: appIndex === index ? '35px' : '30px',
          }}
        />
      ))}
    </div>
  );
}

const App = () => {
  const [appIndex, setAppIndex] = useState(0);

  return (
    <div className="container">
      <main className="main-content">
        <Title />

        <div className="showcase-section">
          <AppIcon appIndex={appIndex} setAppIndex={setAppIndex} />
          <AppList appIndex={appIndex} setAppIndex={setAppIndex} />
          <ScreenShots appIndex={appIndex} />
        </div>
      </main>
    </div>
  );
}

export default App;
